import { RadioGroupOption, SelectOptionElement } from '@odin-labs/components';
import {
  Contractor,
  JobsiteContractor,
  StripePaymentMethod,
} from 'apollo/generated/client-operations';

export type ContractorForOption = Pick<
  Contractor,
  'contractorId' | 'isDefaultContractor'
> & {
  organization: Pick<Contractor['organization'], 'name'>;
};

export type ContractorOptionElement = SelectOptionElement; // & Pick<Contractor, 'isDefaultContractor'>;

export const getContractorsOptions = (
  contractors: ContractorForOption[],
): ContractorOptionElement[] =>
  contractors
    ?.filter(({ isDefaultContractor }) => !isDefaultContractor)
    .map(({ contractorId: value, organization: { name: label } }) => ({
      label,
      value,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

export type JobsiteContractorForOption = {
  contractor: ContractorForOption;
} & Pick<JobsiteContractor, 'startDate' | 'id'>;

export type JobsiteContractorOptionElement = ContractorOptionElement &
  Pick<JobsiteContractor, 'startDate' | 'id'>;

export const getJobsiteContractorsOptions = (
  jobsiteContractors: JobsiteContractorForOption[],
): JobsiteContractorOptionElement[] =>
  jobsiteContractors
    ?.map(
      ({
        id,
        contractor: {
          contractorId: value,
          organization: { name: label },
          isDefaultContractor,
        },
        startDate,
      }) => ({ label, value, startDate, isDefaultContractor, id }),
    )
    .filter(({ isDefaultContractor }) => !isDefaultContractor)
    .sort((a, b) => a.label.localeCompare(b.label));

export type JobsiteContractorRadioGroupOption = RadioGroupOption &
  Pick<JobsiteContractor, 'startDate' | 'id'> &
  Pick<Contractor, 'isDefaultContractor' | 'contractorId'>;

export const getJobsiteContractorsRadioGroupOptions = (
  jobsiteContractors: JobsiteContractorForOption[],
): JobsiteContractorRadioGroupOption[] =>
  jobsiteContractors
    ?.map<JobsiteContractorRadioGroupOption>(
      ({
        id,
        contractor: {
          contractorId,
          organization: { name: label },
          isDefaultContractor,
        },
        startDate,
      }) => ({
        label,
        value: contractorId,
        startDate,
        isDefaultContractor,
        id,
        contractorId,
      }),
    )
    .filter(({ isDefaultContractor }) => !isDefaultContractor)
    .sort((a, b) => a.label.toString().localeCompare(b.label.toString()));

export const generateStripePaymentMethodDisplayValue = (
  paymentMethod: StripePaymentMethod,
): string =>
  `**** ${paymentMethod.last4} exp: ${paymentMethod.expMonth}/${paymentMethod.expYear}`;
